(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-products-slider')) {
    customElements.define(
      'bundle-products-slider',
      class BundleProductsSlider extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-viewport]');
          if (!this.viewport) return;

          this.prevBtn = this.querySelector('[data-prev]');
          this.nextBtn = this.querySelector('[data-next]');
          this.dotsWrap = this.querySelector('[data-dots]');
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this._update = this._update.bind(this);

          this.viewport.addEventListener('scroll', this._onScroll.bind(this), { passive: true });
          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._page(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._page(1));
          this.viewport.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); this._page(1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); this._page(-1); }
          });

          if ('ResizeObserver' in window) {
            this._ro = new ResizeObserver(this._update);
            this._ro.observe(this.viewport);
          }

          this._buildDots();
          this._update();
        }

        disconnectedCallback() {
          if (this._ro) this._ro.disconnect();
        }

        /*
          Paging is measured in whole cards, not viewport widths. The old
          Math.round(scrollWidth / clientWidth) collapsed a 5-card / 4-column
          slider (1.25 viewports) to a single page, so "next" never enabled
          and the 5th card was unreachable by arrow, while 6 cards (1.5
          viewports) rounded up to 2 pages and worked.
        */
        get _slides() {
          return this.viewport.querySelectorAll('.bundle-products__slide');
        }

        /* Distance from one card's left edge to the next (card width + gap) */
        get _step() {
          const s = this._slides;
          if (!s.length) return 1;
          if (s.length > 1) {
            const d = s[1].offsetLeft - s[0].offsetLeft;
            if (d > 0) return d;
          }
          return s[0].offsetWidth || 1;
        }

        get _perView() {
          return Math.max(1, Math.round((this.viewport.clientWidth || 1) / this._step));
        }

        get _pageWidth() {
          return this._perView * this._step;
        }

        get _maxScroll() {
          return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        }

        get _atEnd() {
          return this.viewport.scrollLeft >= this._maxScroll - 1;
        }

        get _pageCount() {
          return Math.max(1, Math.ceil(this._slides.length / this._perView));
        }

        get _current() {
          const count = this._pageCount;
          if (this._atEnd) return count - 1;
          return Math.min(count - 1, Math.max(0, Math.round(this.viewport.scrollLeft / this._pageWidth)));
        }

        _page(dir) {
          this._goTo(this._current + dir);
        }

        _goTo(index) {
          const i = Math.min(this._pageCount - 1, Math.max(0, index));
          this.viewport.scrollTo({
            left: i >= this._pageCount - 1 ? this._maxScroll : i * this._pageWidth,
            behavior: this.reduced ? 'auto' : 'smooth',
          });
        }

        _onScroll() {
          if (this._raf) return;
          this._raf = window.requestAnimationFrame(() => {
            this._raf = null;
            this._syncState();
          });
        }

        _buildDots() {
          if (!this.dotsWrap || !this.hasAttribute('data-dots-enabled')) return;
          const count = this._pageCount;
          this.dotsWrap.innerHTML = '';
          if (count <= 1) {
            this.dotsWrap.hidden = true;
            return;
          }
          this.dotsWrap.hidden = false;
          for (let i = 0; i < count; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'bundle-products__dot';
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.addEventListener('click', () => this._goTo(i));
            this.dotsWrap.appendChild(dot);
          }
        }

        _syncState() {
          const current = this._current;
          if (this.prevBtn) this.prevBtn.disabled = this.viewport.scrollLeft <= 1;
          if (this.nextBtn) this.nextBtn.disabled = this._atEnd;
          if (this.dotsWrap) {
            Array.prototype.forEach.call(this.dotsWrap.children, (dot, i) => {
              dot.setAttribute('aria-current', i === current ? 'true' : 'false');
            });
          }
        }

        _update() {
          const fits = this.viewport.scrollWidth <= this.viewport.clientWidth + 1;
          this.toggleAttribute('data-fits', fits);
          if (this.dotsWrap && this.dotsWrap.children.length !== this._pageCount) {
            this._buildDots();
          }
          this._syncState();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vivana-pack-options"] && !Shopify.designMode) return;
  try {
    (function () {
    // Suppress the Appstle-reset listener while we programmatically clear a plan
    // (harmless once Appstle is removed — the listener simply never fires then).
    var suppressReset = false;

    // Temporary debug logging. Enable with ?vivana_debug=1 or
    // localStorage.setItem('vivana_debug','1'). Logs the selected main variant,
    // the matched subscription (bundle) variant, the id/qty that will be added,
    // and the pack type — for verifying variant resolution end-to-end.
    var DEBUG = (function () {
      try {
        return /[?&]vivana_debug=1/.test(location.search) || localStorage.getItem('vivana_debug') === '1';
      } catch (e) { return false; }
    })();
    function dlog() {
      if (DEBUG && window.console) console.log.apply(console, ['[Vivana pack]'].concat([].slice.call(arguments)));
    }

    function priceEl(productId) {
      return document.querySelector('product-price[data-product-id="' + productId + '"]');
    }

    function forceAppstleOneTime() {
      // Best-effort: if the Appstle widget is still present, put it on one-time so
      // no selling plan rides along. No-op once Appstle is removed.
      suppressReset = true;
      var oneTime = document.querySelector('input[name="selling_plan"][value=""]');
      if (oneTime && !oneTime.checked) {
        oneTime.checked = true;
        oneTime.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var field = document.querySelector('form[action*="/cart/add"] [name="selling_plan"]');
      if (field && 'value' in field && field.value) {
        field.value = '';
      }
      setTimeout(function () { suppressReset = false; }, 350);
    }

    class VivanaPackOptions extends HTMLElement {
      connectedCallback() {
        if (this._placing) { this._placing = false; return; }
        if (this._initialized) { this.place(); return; }
        this._initialized = true;

        this.productId = this.getAttribute('data-product-id');
        this.mainVariantIds = (this.getAttribute('data-main-variant-ids') || '')
          .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        this.mainUrl = this.getAttribute('data-main-url') || '';
        this.bundleVariantId = this.getAttribute('data-bundle-variant');
        this.soldoutText = this.getAttribute('data-soldout-text') || 'Sold out';
        this.priceEl = priceEl(this.productId);
        this.data = this._readData();
        this._variantMap = this._buildVariantMap();

        var self = this;
        this.addEventListener('change', function (e) {
          var input = e.target;
          if (!input || input.type !== 'radio') return;
          var card = input.closest('.vivana-pack-card');
          if (card) self.select(card);
        });

        this._bindVariantChange();
        // When the mandatory-variant controller clears its awaiting state (a variant
        // was chosen), apply the currently-selected pack's price now that pricing is
        // no longer deferred.
        document.addEventListener('vivana:awaiting-cleared', function () { self._refreshVariant(); });
        this.place();
        this.observeForm();

        // Resolve the bundle variant matching the current flavor, sync prices, and
        // select the default-checked card (falls back to plain one-time).
        this._refreshVariant();
        if (!this.querySelector('.vivana-pack-card input:checked') && !window.VivanaPackState) {
          window.VivanaPackState = { mode: 'one-time' };
        }
      }

      /* ---- Dynamic flavor → bundle-variant matching ---- */

      _readData() {
        try {
          var s = this.querySelector('script[data-vivana-pack-data]');
          return s ? JSON.parse(s.textContent) : null;
        } catch (e) { return null; }
      }

      _norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

      _currentMainVariantId() {
        var form = this.form();
        var input = form && form.querySelector('[name="id"]');
        var v = input ? String(input.value) : '';
        return v || (this.mainVariantIds[0] || '');
      }

      _findMain(id) {
        var list = (this.data && this.data.main) || [];
        for (var i = 0; i < list.length; i++) {
          if (String(list[i].id) === String(id)) return list[i];
        }
        return list[0] || null;
      }

      /** Bundle variant whose option value(s) best overlap the selected MAIN
       *  variant's (e.g. "Pomegranate"). Prefers available variants; falls back to
       *  the first available, then the first. A single-variant bundle always
       *  resolves to its one variant. No hardcoded ids or flavor names. */
      _matchBundleVariant(mainOpts) {
        var list = (this.data && this.data.bundle) || [];
        if (!list.length) return null;
        var self = this;
        var wanted = (mainOpts || []).map(function (o) { return self._norm(o); });
        var best = null, bestScore = -1;
        list.forEach(function (bv) {
          if (bv.available === false) return;
          var score = 0;
          (bv.opts || []).forEach(function (o) {
            if (wanted.indexOf(self._norm(o)) !== -1) score++;
          });
          if (score > bestScore) { bestScore = score; best = bv; }
        });
        if (!best) {
          for (var i = 0; i < list.length; i++) { if (list[i].available !== false) { best = list[i]; break; } }
        }
        return best || list[0];
      }

      /** Map every MAIN variant id -> its matched BUNDLE variant id, so the add
       *  interceptor can resolve the correct flavor from the variant id in the
       *  /cart/add payload (always current) rather than a cached selection. */
      _buildVariantMap() {
        var map = {};
        if (!this.data || !this.data.main || !this.data.bundle) return map;
        var self = this;
        this.data.main.forEach(function (mv) {
          var bv = self._matchBundleVariant(mv.opts || []);
          if (bv && bv.id != null) map[String(mv.id)] = String(bv.id);
        });
        return map;
      }

      _refreshVariant() {
        if (this.data) {
          var mv = this._findMain(this._currentMainVariantId());
          var bv = this._matchBundleVariant(mv ? mv.opts : []);
          this._activeMain = mv;
          this._activeBundle = bv;
          if (bv && bv.id != null) this.bundleVariantId = String(bv.id);
          dlog(
            'variant refresh — main:', this._currentMainVariantId(), mv && mv.opts,
            '→ matched bundle:', bv && bv.id, bv && bv.opts,
            '| three now:', mv && mv.threeNow, '| six now:', mv && mv.sixNow, '| bundle available:', bv && bv.available
          );
          this._applyCardPrices();
        }
        // Static header "From <lowest> <RRP>" for the active variant (flavor).
        this.renderHeaderFrom();
        var checked = this.querySelector('.vivana-pack-card input:checked');
        if (checked) this.select(checked.closest('.vivana-pack-card'));
      }

      /** Sync each card's price/availability to the active main + bundle variant. */
      _applyCardPrices() {
        var self = this;
        var b = this._activeBundle, m = this._activeMain;
        this.querySelectorAll('.vivana-pack-card').forEach(function (card) {
          var mode = card.getAttribute('data-pack-mode');
          var now, was, avail = true;
          // Price for every option = the main (single product) variant price with
          // its discount; availability for 3/6-month = the matched bundle variant.
          if (mode === 'three') { if (m) { now = m.threeNow; was = m.threeWas; } if (b) avail = b.available !== false; }
          else if (mode === 'six') { if (m) { now = m.sixNow; was = m.sixWas; } if (b) avail = b.available !== false; }
          else { if (m) { now = m.oneNow; was = m.oneWas; } }
          if (now == null) return; // no data — keep server-rendered
          card.setAttribute('data-now', now);
          card.setAttribute('data-was', was || '');
          var priceEl = card.querySelector('.vivana-pack-card__price');
          var input = card.querySelector('input[type="radio"]');
          if (avail) {
            card.classList.remove('vivana-pack-card--soldout');
            if (input) input.disabled = false;
            if (priceEl) {
              // "/month" on the multi-month options only (3M / 6M).
              var per = (mode === 'three' || mode === 'six') ? '<span class="vivana-pack-card__per">/month</span>' : '';
              priceEl.className = 'vivana-pack-card__price';
              priceEl.innerHTML = '<span class="vivana-pack-card__price-now">' + now + per + '</span>' +
                (was ? '<s class="vivana-pack-card__price-was">' + was + '</s>' : '');
            }
          } else {
            card.classList.add('vivana-pack-card--soldout');
            if (input) { input.disabled = true; input.checked = false; }
            if (priceEl) { priceEl.className = 'vivana-pack-card__price vivana-pack-card__soldout'; priceEl.textContent = self.soldoutText; }
          }
        });
      }

      /** Re-match when the shopper changes the main product variant (flavor). */
      _bindVariantChange() {
        var self = this;
        this._lastMainId = this._currentMainVariantId();
        document.addEventListener('change', function (e) {
          var t = e.target;
          if (t && typeof t.name === 'string' && t.name.indexOf('vivana-pack-') === 0) return;
          requestAnimationFrame(function () {
            var id = self._currentMainVariantId();
            if (id && id !== self._lastMainId) { self._lastMainId = id; self._refreshVariant(); }
          });
        });
      }

      disconnectedCallback() {
        if (this._placing) return;
        if (this._obs) { this._obs.disconnect(); this._obs = null; }
      }

      form() {
        var scope = this.closest('.shopify-section') || document;
        return scope.querySelector('form[action*="/cart/add"]');
      }

      place() {
        var form = this.form();
        var buttons = form && form.querySelector('.product-form-buttons');
        if (!buttons || !buttons.parentNode) return;
        // Keep the pack options above the mandatory-variant validation message
        // when it is present, so the running order stays: pack options → message
        // → button row (message sits directly above Add to Cart). Without this the
        // message would be bumped above the packs on every re-assert.
        var anchor = buttons;
        var prev = buttons.previousElementSibling;
        if (prev && prev.classList && prev.classList.contains('vivana-variant-required-msg')) {
          anchor = prev;
        }
        if (anchor.previousElementSibling === this) return;
        this._placing = true;
        anchor.parentNode.insertBefore(this, anchor);
      }

      observeForm() {
        if (this._obs) return;
        var form = this.form();
        if (!form || typeof MutationObserver === 'undefined') return;
        var self = this;
        this._obs = new MutationObserver(function () { self.place(); });
        this._obs.observe(form, { childList: true, subtree: true });
      }

      // Non-destructive price preview: swap the native price numbers for the pack's
      // (kept in sync via data-* money strings), reusing the theme's price classes.
      /** The element that wraps the native price numbers. Rendering our preview
       *  INSIDE it (reusing the theme's .price / .compare-at-price classes) makes
       *  the preview typography identical to the native price in every state and
       *  at every breakpoint — a single source of truth for price styling. */
      priceContainer() {
        if (!this.priceEl) return null;
        return this.priceEl.querySelector('[ref="priceContainer"]') || this.priceEl;
      }

      /** Render the STATIC "From <lowest> <RRP>" header price under the product
       *  title. It reuses the theme's .price / .compare-at-price classes (so the
       *  typography matches natively) and does NOT change with the selected supply
       *  option — only recomputed per variant (flavor). */
      renderHeaderFrom() {
        if (!this.priceEl) return;
        var container = this.priceContainer();
        if (!container) return;
        var m = this._activeMain;
        var fromNow, rrp;
        if (m) { fromNow = m.fromNow || ''; rrp = m.rrp || ''; }
        else { fromNow = this.getAttribute('data-from-now') || ''; rrp = this.getAttribute('data-from-was') || ''; }
        if (!fromNow) { this.restorePrice(); return; }
        var label = this.getAttribute('data-from-label') || 'From';
        if (!this._override) {
          this._override = document.createElement('span');
          this._override.className = 'vivana-pack-price-override';
        }
        if (this._override.parentNode !== container) container.appendChild(this._override);
        this._override.innerHTML =
          '<span class="price"><span class="vivana-pack-from-label">' + label + '</span> ' + fromNow + '</span>' +
          (rrp ? '<span class="compare-at-price">' + rrp + '</span>' : '');
        this._override.hidden = false;
        container.classList.add('vivana-has-pack-override');
      }

      restorePrice() {
        if (this._override) this._override.hidden = true;
        var container = this.priceContainer();
        if (container) container.classList.remove('vivana-has-pack-override');
      }

      resetToOneTime() {
        this.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
          r.checked = false;
        });
        window.VivanaPackState = { mode: 'one-time' };
        this.renderHeaderFrom();
      }

      select(card) {
        if (!card) return;
        var mode = card.getAttribute('data-pack-mode');
        dlog(
          'select pack:', mode,
          '| bundle variant id to add:', (mode === 'three' || mode === 'six') ? this.bundleVariantId : '(main product / no swap)',
          '| qty multiplier:', mode === 'six' ? 2 : 1,
          '| cart label:', card.getAttribute('data-pack-label') || '(none)'
        );
        if (mode === 'three' || mode === 'six') {
          window.VivanaPackState = {
            mode: mode,
            bundleVariantId: this.bundleVariantId,
            variantMap: this._variantMap,
            label: card.getAttribute('data-pack-label') || '',
            mainVariantIds: this.mainVariantIds,
            mainUrl: this.mainUrl,
          };
          dlog('pack state set — variantMap (main→bundle):', this._variantMap, '| default bundle:', this.bundleVariantId);
          forceAppstleOneTime();
        } else {
          // One-Month = plain main product, one-time (no swap).
          window.VivanaPackState = { mode: 'one-time' };
          forceAppstleOneTime();
        }
        // The header price is a STATIC "From <lowest>" (see renderHeaderFrom); it
        // does NOT change with the selected supply option. Each card shows its own
        // price in the widget.
      }
    }

    // If an Appstle subscription is chosen (while Appstle is still present), drop
    // our selection back to one-time. Guarded so our own clearing doesn't loop.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'selling_plan') return;
      if (suppressReset) return;
      var el = document.querySelector('vivana-pack-options');
      if (el && typeof el.resetToOneTime === 'function') el.resetToOneTime();
    });

    if (!customElements.get('vivana-pack-options')) {
      customElements.define('vivana-pack-options', VivanaPackOptions);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
